module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap opti_wrap",
    class: {
      pd110: _vm.btnFixed
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "loading-wrap",
    style: (_vm.togg())
  }, [_vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flow_top flow_input_bg"
  }, [_c('img', {
    staticClass: "main-top",
    attrs: {
      "src": _vm.mode == 1 || _vm.mode == 2 ? _vm.inputBgImgSrc1_2 : _vm.inputBgImgSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "formElement1",
    class: {
      flow_select3: _vm.mode == 3, flow_select: _vm.mode == 0, flow_select1: _vm.mode == 1 || _vm.mode == 2
    }
  }, [(_vm.step == 1) ? _c('i', {
    staticClass: "hand-step1"
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "formBox van-cell-group van-hairline--top-bottom"
  }, [_c('div', {
    staticClass: "form phone van-cell van-cell--required van-field"
  }, [_c('div', {
    staticClass: "van-cell__value van-cell__value--alone van-field__value"
  }, [_c('div', {
    staticClass: "van-field__body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phonenum),
      expression: "phonenum"
    }],
    staticClass: "van-field__control",
    attrs: {
      "type": "tel",
      "id": "inputPhone",
      "placeholder": "请输入你的手机号"
    },
    domProps: {
      "value": (_vm.phonenum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phonenum = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('i', {
    staticClass: "hand-step2"
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 3) ? _c('div', {
    staticClass: "formBox formBoxPhone van-cell-group van-hairline--top-bottom"
  }, [_c('div', {
    staticClass: "form phone van-cell van-cell--required van-field"
  }, [_c('div', {
    staticClass: "van-cell__value van-cell__value--alone van-field__value"
  }, [_c('div', {
    staticClass: "van-field__body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    staticClass: "van-field__control",
    attrs: {
      "type": "number",
      "inputmode": "decimal",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.timesCount === 0) ? _c('div', {
    staticClass: "van-field__button",
    on: {
      "click": _vm.bindOpen
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "van-field__button"
  }, [_c('div', {
    staticStyle: {
      "color": "rgb(240, 169, 25)",
      "font-size": "0.28rem",
      "height": "1.1rem",
      "line-height": "1.1rem"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.2rem",
      "position": "relative",
      "top": "-0.02rem"
    }
  }, [_vm._v("|")]), _vm._v(_vm._s(_vm.timesCount) + "\n                                ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.mode == 1 || _vm.mode == 2) ? _c('div', {
    attrs: {
      "id": "cap"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "scrolling": "no",
      "id": "frame",
      "name": "frame",
      "src": _vm.capUrl,
      "frameborder": "0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "btn_box"
  }, [_c('img', {
    staticClass: "btn_img",
    class: {
      fixed: _vm.btnFixed
    },
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/theme3/get_btn.png"
    },
    on: {
      "click": _vm.bindOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "product-info"
  }, [_c('p', [_vm._v("开通联合会员，领热门会员+话费")]), _vm._v(" "), _c('p', [_vm._v("业务资费：6-15元/月(具体以实际产品资费为准)")]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "agree"
  }, [(!_vm.checked) ? _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/common/unchecked_yellow.png"
    },
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }) : _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/common/checked_yellow.png"
    },
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }), _vm._v(" "), _c('span', [_c('span', {
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }, [_vm._v("我已详细阅读并同意")]), _vm._m(4), _vm._v("及相关条款")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flow_txtBox"
  }, [_c('div', {
    staticClass: "flow-title1",
    on: {
      "click": _vm.showActivityOrNot
    }
  }, [_vm._v("活动说明\n            "), (!_vm.visibleNotes) ? _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-down.png",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visibleNotes) ? _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-up.png",
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.visibleNotes) ? _c('div', {
    staticClass: "notes"
  }, [_vm._m(5)]) : _vm._e()]), _vm._v(" "), (_vm.mifaChannel.indexOf(_vm.channelid) > -1 || _vm.youzhengChannel.indexOf(_vm.channelid) > -1) ? _c('div', {
    staticClass: "flow_txtBox",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    staticClass: "flow-title1",
    on: {
      "click": _vm.showPrivacyBoxOrNot
    }
  }, [_vm._v("隐私协议\n            "), (!_vm.showPrivacy) ? _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-down.png",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacy) ? _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-up.png",
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showPrivacy) ? _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('p', [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('p', [_vm._v("1、尊重与保护用户个人信息是本服务的一项基本原则。")]), _vm._v(" "), _c('p', [_vm._v("2、本业务需采集用户的个人信息包括：手机号码、IP地址。 ")]), _vm._v(" "), _c('p', [_vm._v("3、用户同意本服务基于以下事项使用用户的个人信息：")]), _vm._v(" "), _c('p', [_vm._v("（1）读取、上传、记录用户个人信息数据并进行同步、分享和储存以实现部分服务功能；")]), _vm._v(" "), _c('p', [_vm._v("（2）收集用户个人信息数据并统计、分析及研究，以改进本服务的质量；")]), _vm._v(" "), _c('p', [_vm._v("（3）改进或提高用户的使用安全性和服务性； ")]), _vm._v(" "), _c('p', [_vm._v("（4）向用户发送本服务的重要通知和服务信息； ")]), _vm._v(" "), _c('p', [_vm._v("（5）适用法律法规规定的其他事项。 （可根据应用实际情况修改补充）除上述事项外，如未取得用户事先同意，本应用不会将用户个人信息使用于任何其他用途。 ")]), _vm._v(" "), _c('p', [_vm._v("4、本服务采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、毁损或丢失。 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._v("5、本服务承诺未经用户同意不向任何第三方公开、透露用户个人信息，但法律法规规定或有权机关的指示提供用户的个人信息除外。")]), _vm._v(" "), _c('div', {
    staticClass: "flow-title1",
    staticStyle: {
      "color": "#000"
    },
    on: {
      "click": _vm.iKnow
    }
  }, [_vm._v("我已知晓")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mifaChannel.indexOf(_vm.channelid) > -1) ? _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v("公司名称：广州巧思信息科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("地址：广州市天河区新塘大街3号7栋310-92房")]), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "product-info"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备2021093402号-2")])]) : _vm._e(), _vm._v(" "), (_vm.isGdt) ? _c('div', {
    staticClass: "ftxs_main"
  }, [_c('img', {
    staticClass: "benefit-bg",
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/common/bottom.jpg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('qs-msg-box', {
    attrs: {
      "isloading": _vm.isLoading,
      "msg": _vm.msg,
      "flag": _vm.flag
    }
  }), _vm._v(" "), _c('qs-quit-box', {
    attrs: {
      "showQuitModal": _vm.showQuitModal,
      "channelId": _vm.channelid,
      "phone": _vm.phonenum,
      "tuiaId": _vm.advertId
    },
    on: {
      "closeQuitModal": _vm.closeQuitModal
    }
  }), _vm._v(" "), _c('page-close-mask', {
    attrs: {
      "showMask": _vm.pageClose
    }
  }), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "width": "100%",
      "scrolling": "no",
      "src": _vm.productUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "border-radius": "10px",
      "padding-left": "0px"
    },
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/images/loading-img.gif"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "color": "white",
      "padding": "10px 6px"
    }
  }, [_vm._v("稍等片刻~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow_top"
  }, [_c('img', {
    staticClass: "main-top",
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/theme0222/top.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "rgb(240, 169, 25)",
      "font-size": "0.28rem",
      "height": "1.1rem",
      "line-height": "1.1rem"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.2rem",
      "position": "relative",
      "top": "-0.02rem"
    }
  }, [_vm._v("|")]), _vm._v("获取验证码\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("客服电话："), _c('a', {
    attrs: {
      "href": "tel:4008008663"
    }
  }, [_vm._v("4008008663")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://store.0168.net.cn/activity-mall/privacy/content.html"
    }
  }, [_vm._v("《"), _c('u', [_vm._v("用户隐私协议")]), _vm._v("》")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('p', [_vm._v("1、活动对象：2G/3G/4G/5G用户。")]), _vm._v(" "), _c('p', [_vm._v("2、活动内容：活动期间凡首次在本页面成功开通业务（业务资费：6-15元/月，具体以实际产品资费为准），即可获得热门VIP会员任选一和1-25元随机话费红包（仅开通当月享有一次机会）。热门VIP会员（10选一）：百度网盘普通会员月卡、QQ音乐付费音乐包月卡、饿了么超级会员月卡、喜马拉雅VIP月卡、腾讯视频VIP月卡、优酷视频黄金会员月卡、爱奇艺黄金VIP会员月卡、芒果TV会员月卡、蜻蜓FM月卡、青桔单车月卡。")]), _vm._v(" "), _c('p', [_vm._v("3、权益兑换： ")]), _vm._v(" "), _c('p', [_vm._v("（1）热门权益兑换方式：进入"), _c('a', {
    attrs: {
      "href": "https://mf.0168.net.cn/benefit-platform"
    }
  }, [_vm._v("https://mf.0168.net.cn/benefit-platform")]), _vm._v("，登录后，选择您需要的权益进行兑换。")]), _vm._v(" "), _c('p', [_vm._v("（2）话费权益兑换方式：进入"), _c('a', {
    attrs: {
      "href": "https://mf.0168.net.cn/benefit-platform"
    }
  }, [_vm._v("https://mf.0168.net.cn/benefit-platform")]), _vm._v("，登录后，选择话费面值，点击“立即兑换”。兑换成功后7个工作日内系统自动充值到账； ")]), _vm._v(" "), _c('p', [_vm._v("温馨提示：使用相关权益时，请遵守相应平台的用户服务协议和权益使用协议，如违反相关协定规定，运营商和联合权益提供方均有权单独进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。 ")]), _vm._v(" "), _c('p', [_vm._v("4、注意事项： ")]), _vm._v(" "), _c('p', [_vm._v("（1）每个手机号仅限参与一次；")]), _vm._v(" "), _c('p', [_vm._v("（2）本活动业务为自动续费产品，用户订购期内不退订，下月将进行自动缴费续订； ")]), _vm._v(" "), _c('p', [_vm._v("（3）本业务退订后视作放弃本活动福利礼品，未充值到账或未兑换的礼品将不再发放（福利礼品包括会员、代金券、话费等）； ")]), _vm._v(" "), _c('p', [_vm._v("（4）已开通本业务的老用户不可再次参与本次推广活动。 ")]), _vm._v(" "), _c('p', [_vm._v("5、退订方式： \n                ")]), _c('p', [_vm._v("（1）联通退订方式：进入中国联通APP-服务-我已订购-增值业务-选择相关业务名称-退订，或者发送短信0000至10010，按提示内容退订； ")]), _vm._v(" "), _c('p', [_vm._v("（2）移动退订方式：发送短信0000至10086，按提示内容退订。 ")]), _vm._v(" "), _c('p', [_vm._v("6、由于产品价格可能出现临时调整，具体资费以实际扣费短信为准。")]), _vm._v(" "), _c('p', [_vm._v("7、如有疑问可致电客服热线："), _c('a', {
    attrs: {
      "href": "tel:4008008663"
    }
  }, [_vm._v("4008008663")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("联系电话："), _c('a', {
    attrs: {
      "href": "tel:4008008663"
    }
  }, [_vm._v("4008008663")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-321de6be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/h5/theme0222_2/Theme0222_2.vue
// module id = 968
// module chunks = 60